module.exports = __webpack_public_path__ + "static/media/user.d3569aa1.svg";